module.exports = __webpack_public_path__ + "img/3_11.a46dea95.png";